import { createContext, useContext, useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";
import { Link } from "react-router-dom";

const KEY = "90b_cookie_consent_v1";
const CookieCtx = createContext({ accepted: false, accept: () => {}, reject: () => {} });

export function CookieProvider({ children }) {
  const [state, setState] = useState(null); // null | "accepted" | "rejected"

  useEffect(() => {
    try {
      const v = localStorage.getItem(KEY);
      if (v === "accepted" || v === "rejected") setState(v);
      else setState("pending");
    } catch {
      setState("pending");
    }
  }, []);

  const accept = () => {
    try { localStorage.setItem(KEY, "accepted"); } catch {}
    setState("accepted");
  };
  const reject = () => {
    try { localStorage.setItem(KEY, "rejected"); } catch {}
    setState("rejected");
  };

  return (
    <CookieCtx.Provider value={{ accepted: state === "accepted", state, accept, reject }}>
      {children}
      {state === "pending" && <CookieBanner onAccept={accept} onReject={reject} />}
    </CookieCtx.Provider>
  );
}

export function useCookieConsent() {
  return useContext(CookieCtx);
}

function CookieBanner({ onAccept, onReject }) {
  return (
    <div
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-50 bg-white border-t border-slate-200 shadow-2xl"
    >
      <div className="container-90 py-5 lg:py-6 flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-8">
        <div className="flex items-start gap-4 flex-1">
          <div className="flex-shrink-0 w-11 h-11 bg-[color:var(--brand-blue)] flex items-center justify-center">
            <Cookie className="w-5 h-5 text-white" strokeWidth={1.8} />
          </div>
          <div>
            <div className="font-heading font-bold text-slate-900 mb-1">
              Utilizziamo cookie tecnici
            </div>
            <p className="text-sm text-slate-600 leading-relaxed">
              Questo sito utilizza esclusivamente cookie tecnici necessari al funzionamento.
              Per maggiori informazioni consulta l'{" "}
              <Link
                to="/reclami#documenti"
                className="text-[color:var(--brand-blue)] font-semibold underline-offset-2 hover:underline"
              >
                Informativa Privacy
              </Link>.
            </p>
          </div>
        </div>
        <div className="flex gap-3 flex-shrink-0">
          <button
            data-testid="cookie-reject-btn"
            onClick={onReject}
            className="btn-ghost px-5 py-2 border border-slate-300 hover:border-slate-500"
          >
            Rifiuta
          </button>
          <button
            data-testid="cookie-accept-btn"
            onClick={onAccept}
            className="btn-primary text-sm"
          >
            Accetta e continua
          </button>
        </div>
      </div>
    </div>
  );
}
